import React, {useEffect, useState} from 'react';
//MUI
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

function CustomSearch({searchText, handleSearch, options}) {
   return (
      <div>
         <TextField
            value={searchText || ''}
            onChange={e => handleSearch(e.target.value)}
            placeholder={options?.searchPlaceholder || "Buscar"}
            variant="standard"
            style={{marginRight: '10px', maxWidth: '400px'}}
            InputProps={{
               startAdornment: (
                  <InputAdornment position="start">
                     <SearchIcon />
                  </InputAdornment>
               ),

               endAdornment: (
                  <>
                     {searchText && (
                        <IconButton
                           onClick={() => {
                              handleSearch('');
                              document.querySelector('.MuiInputBase-input').focus();
                           }}
                           size="large">
                           <ClearIcon />
                        </IconButton>
                     )}
                  </>
               )
            }}
            inputProps={{className: 'MuiInputBase-input'}}
            fullWidth
         />
      </div>
   );
}

export default CustomSearch;
